export default __webpack_public_path__ + "static/media/france.4e85af0a.svg";